import qs from '../../scripts/util/DOM/qs';
import isElem from '../../scripts/util/isElement';
import $ from 'jquery';

let loadingFlag = false;
let message;

const selectors = {
	login: '.js-sign-up',
	page: '.page',
	orderForm: '.js-signup-form',
	orderFormErrors: '.signup-form__errors--common',
	orderFormSubmitButton: '.signup-form__submit-button',
	selectItemSelected: '.select__item_state_selected',
	field: '.js-sign-up-input'
};
const addMod = () => {
	const page = qs(selectors.page);
	page.classList.add('page_login_full');
};

const classes = {
	orderFormErrorsShow: 'signup-form__errors--common-show',
	buttonLoading: 'button_type_submit_loading'
};

const setOrderFormHandlers = () => {
	$(selectors.orderForm).on('submit', function (e) {
		e.preventDefault();
		$(selectors.orderFormSubmitButton).addClass(classes.buttonLoading);
		$(selectors.orderFormErrors).removeClass(classes.orderFormErrorsShow).slideUp();

		const inputs = $('.js-signup-form').find('.js-field-input');
		const orderData = {};
		inputs.each(function () {
			let name = $(this).attr('name');
			name = name.replace('user[', '');
			name = name.replace(']', '');
			orderData[name] = $(this).val();
		});
		orderData.source = $(selectors.selectItemSelected).data('value');
		orderData.period = $('#period').val();
		orderData.rubclient = $('#rubclient').val();
		if ($('#design').length > 0) {
			orderData.design = $('#design').val();
		}
		else {
			orderData.design = '';
		}
		orderData.totalamount = $(selectors.chooseTariffButton).data('price');
		orderData.registration = 'n';
		orderData.orderMode = 'order';
		orderData.mailagree = 'y';
		orderData.discount = 'n';

		if (loadingFlag === false) {
			$.ajax({
				url: '/send-site',
				type: 'POST',
				dataType: 'json',
				data: {
					name: orderData.name,
					packageName: 'standard',
					lastname: orderData.lastname,
					email: orderData.email,
					password: orderData.password,
					source: orderData.source,
					period: orderData.period,
					design: orderData.design,
					rubclient: orderData.rubclient,
					totalamount: 125, // orderData.totalamount,
					registration: orderData.registration,
					orderMode: orderData.orderMode,
					mailagree: orderData.mailagree,
					discount: orderData.discount,
					_csrf: $('meta[name="csrf-token"]').prop('content')
				}, xhrFields: {withCredentials: true},
				beforeSend: () => {
					$('.signup-form__preloader').show();
					loadingFlag = true;
				},
				success: response => {
					if (response.status !== 'ok') {
						$(selectors.orderFormSubmitButton).removeClass(classes.buttonLoading);
					}
					loadingFlag = false;
					switch (response.status) {
						case 'ok':
							window.location = response.location;
							break;
						case 'fail':
							message = 'Вы не являетесь клиентом хостинга от Gophotoweb. Пожалуйста, выберите другую опцию по услугам хостинга.';
							$(selectors.orderFormErrors).html(message).addClass(classes.orderFormErrorsShow).slideDown();
							break;
						case 'fail-upgrade':
							message = 'Вы не можете обновить сайт.';
							$(selectors.orderFormErrors).html(message).addClass(classes.orderFormErrorsShow).slideDown();
							break;
						case 'create-new-account':
							message = 'Пользователь с таким адресом электронной почты уже зарегистрирован. <a href="' + $('#clientarea').val() + '">Войти в свой аккаунт</a>.';
							$(selectors.orderFormErrors).html(message).addClass(classes.orderFormErrorsShow).slideDown();
							break;
						default:
							message = 'Ошибка при отправке заявки. Пожалуйста, заполните поля заявки еще раз и нажмите кнопку отправить.';
							$(selectors.orderFormErrors).html(message).addClass(classes.orderFormErrorsShow).slideDown();
							break;
					}
				},
				error: (qXHR, textStatus, errorThrown) => {
					loadingFlag = false;
					console.log('Order page error. XHR response text - ' + qXHR.responseText + ' XHR Status - ' + qXHR.status + '. Error status - ' + textStatus + '.  Error text - ' + errorThrown);
					$(selectors.orderFormSubmitButton).removeClass(classes.buttonLoading);
					message = 'Ошибка при отправке заявки. Пожалуйста, заполните поля заявки еще раз и нажмите кнопку отправить.';
					$(selectors.orderFormErrors).html(message).addClass(classes.orderFormErrorsShow).slideDown();
				},
				complete: (qXHR, textStatus) => {
					console.log(qXHR, textStatus);
					loadingFlag = false;
				}
			});
		}
	});

	$(selectors.field).on('focusin', function () {
		$(this).removeClass('field__input_state_error');
		if ($(this).attr('name') !== 'user[name]' && $(this).attr('name') !== 'user[lastname]') {
			$(this).closest('.field').find('.field__wrap-input-error').removeClass('signup-form__errors--show').slideUp();
		}
	});


	$(selectors.field).on('focusout', function () {
		$(selectors.orderForm).trigger('validate.csssr');
		const self = $(this);

		if ($(this).hasClass('field__input_state_error')) {
			const error = $(this).data('invalid-message');
			$(this).closest('.field').find('.field__wrap-input-error').text(error).addClass('signup-form__errors--show').slideDown();
		}
		let counter = 0;
		$(selectors.field).each(function (index, item) {
			if ($(item).hasClass('field__input_state_error') && !$(item).closest('.field').find('.field__wrap-input-error').hasClass('signup-form__errors--show') && $(item).attr('name') !== self.attr('name')) {
				$(item).removeClass('field__input_state_error');
			}
			if ($(item).hasClass('field__input_state_error')) {
				counter++;
			}
		});

		if (!$('#name').hasClass('field__input_state_error') && !$('#lastname').hasClass('field__input_state_error')) {
			$('.field__wrap-input-error--twice').removeClass('signup-form__errors--show').slideUp();
		}

		if (counter === 0) {
			$('.signup-form__errors--show').removeClass('signup-form__errors--show').slideUp();
		}


	});

	$('.signup-form__submit-button').on('click', function () {
		setTimeout(function () {
			$(selectors.field).each(function (index, item) {
				if ($(item).hasClass('field__input_state_error')) {
					const error = $(item).data('invalid-message');
					$(item).closest('.field').find('.field__wrap-input-error').text(error).slideDown();
				}
			});
		}, 300);
	});
};

const render = () => {
	if (isElem(selectors.login)) {
		addMod();
		setOrderFormHandlers();
	}
};

export default render;
